import {ACCESS_TOKEN_KEY} from "../constants/localStorage";

export function getBearerToken() {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY)

    if (token) {
        return `Bearer ${token}`
    }
}